import { useBlogPosts } from '@streamr/streamr-layout'
import GhostContentAPI from '@tryghost/content-api'

const api = new GhostContentAPI({
    url: 'https://streamr.ghost.io',
    key: 'e1257cb1e62674f4be947563d4',
    version: 'v3',
})

export default (params = {}) => (
    useBlogPosts(api, params)
)
